/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Input, ModalHeader, ModalBody, ModalFooter, Button, Select, SelectItem, Textarea } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { formatAmount, formatToApi, fromPhotos, getOnlyNumbers, adjustAmount, Constants } from '../../../utils';
import { IconImageEdit } from '../../../assets/icons';
import { PlansService } from '../../../services';

const TYPE = {
  PAID: '1',
  FREE: '2',
}

const DURATION = {
  MONTHLY: '1',
  ANNUAL: '2',
}

const planType = [
  { value: TYPE.PAID, label: 'Pago' },
  { value: TYPE.FREE, label: 'Gratuito' },
]

// const durations = [
//   { value: DURATION.MONTHLY, label: 'Mensual' },
//   { value: DURATION.ANNUAL, label: 'Anual' },
// ]

const ModalCreatePlan = ({ plan, onSuccess, onClose, planFor }) => {
  const { form, onChange, onSubmit, isLoading } = useForm(plan, planFor);

  const submit = async () => {
    const isSuccess = await onSubmit();
    if (isSuccess) onSuccess();
  }


  return (
    <>
      <ModalHeader className="flex flex-col gap-1">{!!plan ? 'Editar' : 'Nuevo'} plan {planFor === Constants.PLAN_FOR.SCHOOL ? 'Colegio' : 'Profesores'} </ModalHeader>
      <ModalBody className="gap-4">
        <div className="flex items-center justify-start">
          <label htmlFor="photo" className="cursor-pointer text-center border-2 border-gray w-12 h-12 rounded-lg flex justify-center items-center self-center overflow-hidden">
            {!!form.photoUrl ? (
              <img className="w-full h-full object-cover" src={form.photoUrl} alt="Foto del colegio" />
            ) : (
              <img className="w-8 object-contain opacity-50" src={IconImageEdit} alt="Foto del colegio" />
            )}
            <input
              id="photo"
              type="file"
              accept="image/*"
              hidden
              onChange={e => onChange(e.target.files[0], 'photo')}
            />
          </label>

          <div className="flex flex-col ml-4 text-sm">
            <span className="font-medium leading-3">Subir imagen alusiva al plan</span>
          </div>
        </div>

        <Input
          label="Nombre"
          labelPlacement="outside"
          placeholder=" "
          radius="sm"
          variant="bordered"
          value={form.name}
          onValueChange={v => onChange(v, 'name')}
        />
        <Textarea
          classNames={{ label: 'font-semibold' }}
          label="Beneficios y/o condiciones"
          labelPlacement="outside"
          placeholder=" "
          radius="sm"
          variant="bordered"
          value={form.description}
          onValueChange={v => onChange(v, 'description')}
        />
        <Select
          label="Tipo de plan"
          labelPlacement="outside"
          placeholder=" "
          variant="bordered"
          radius="sm"
          classNames={{ label: 'font-semibold' }}
          disallowEmptySelection={true}
          selectedKeys={!!form._type ? [form._type] : []}
          onSelectionChange={v => onChange(v.currentKey, '_type')}
        >
          {planType.map((item) => (
            <SelectItem key={item.value} value={item.value}>{item.label}</SelectItem>
          ))}
        </Select>
        {form._type === TYPE.PAID && (
          <Input
            classNames={{ input: 'text-center text-primary text-lg !text-transparent' }}
            label="Costo"
            labelPlacement="outside"
            placeholder=" "
            isClearable
            onClear={() => onChange('', 'price')}
            startContent={(
              <span
                className="absolute w-[calc(100%-3rem)] overflow-hidden text-center text-primary font-semibold text-lg"
                onClick={e => e.target.nextElementSibling.focus()}
              >
                ${form.price_formatted}
              </span>
            )}
            radius="sm"
            variant="bordered"
            value={form.price}
            onValueChange={v => onChange(getOnlyNumbers(v), 'price')}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cerrar</Button>
        <Button
          className="bg-green"
          color="primary"
          onPress={submit}
          isLoading={isLoading}
          isDisabled={isLoading}
        >
          {!!plan ? 'Editar' : 'Guardar'}
        </Button>
      </ModalFooter>
    </>
  )
}

const useForm = (plan, planFor) => {
  const initialForm = {
    photo: {},
    photoUrl: '',
    name: '',
    description: '',
    _type: '',
    type: DURATION.MONTHLY,
    price: '',
    price_formatted: '0.00',
    hasFile: true,
    for: planFor
  };
  const [isLoading, setIsLoading] = useState(false)
  const [form, setForm] = useState(initialForm);

  const onChange = (value, target) => {
    if (target === 'photo' && !!value) {
      setForm(s => ({ ...s, photoUrl: URL.createObjectURL(value) }));
    }

    setForm(s => ({
      ...s,
      [target]: value,
      price_formatted: target === 'price'
        ? formatAmount(value / 100)
        : s.price_formatted,
    }));
  }

  const onError = (msg) => {
    toast.error(msg);
    return false;
  }

  const isValidForm = () => {
    if (!form.photo)
      return onError('Debe subir un icono');

    if (!form.name)
      return onError('Debe indicar el nombre');

    if (!form.description)
      return onError('Debe indicar los beneficios y/o condiciones');

    if (!form.type)
      return onError('Debe indicar la duración de la suscripción');

    if (form._type === TYPE.PAID && !form.price)
      return onError('Debe indicar el precio');

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;
    setIsLoading(true);
    try {
      const isFree = +form.price === 0 || form._type === TYPE.FREE;
      const _form = {
        ...form,
        price: isFree ? 0 : formatToApi(form.price_formatted),
      };

      if (!!plan) {
        await PlansService.plan.update({ ..._form, id: plan.id });
        toast.success('Plan actualizado correctamente');
      } else {
        await PlansService.plan.create({ ..._form });
        toast.success('Plan creado correctamente');
      }
      setIsLoading(false);
      return true;
    } catch (error) {
      onError(String(error));
      setIsLoading(false)
      return false;
    }
  }

  useEffect(() => {
    if (!!plan) setForm({
      photo: {},
      photoUrl: !!plan?.icon ? fromPhotos(plan.icon) : '',
      name: plan?.name,
      description: plan?.description,
      type: plan?.type?.toString(),
      _type: plan?.price === 0 ? TYPE.FREE : TYPE.PAID,
      price: adjustAmount(plan?.price || 0),
      price_formatted: formatAmount(plan?.price || 0),
      for: plan?.for,
      hasFile: true,
    });
  }, []);

  return {
    form,
    onChange,
    onSubmit,
    isLoading,
  }
}

export default ModalCreatePlan;
